// Composer view of a validated Kambi outcome. Live outcomes carry `feed_leg`,
// the label, subtitle, market and provider payload the published feed card
// will use; cached outcomes do not, so they fall back to the raw fields.

export function kambiOutcomeLabel(outcome) {
  if (outcome?.feed_leg?.label) return outcome.feed_leg.label
  const selectionName = outcome?.selection_name || ''
  const participant = outcome?.participant || ''
  if (participant && selectionName && !selectionName.toLowerCase().includes(participant.toLowerCase())) {
    return `${participant} - ${selectionName}`
  }
  return selectionName || participant || ''
}

export function kambiOutcomePreviewLeg(outcome, event) {
  const feedLeg = outcome.feed_leg
  if (feedLeg) {
    return {
      label: feedLeg.label,
      subtitle: feedLeg.subtitle,
      event: {
        name: outcome.event_name || '',
        id: event?.id,
        start_time: event?.start || outcome.event_start || null,
      },
      market: {
        name: feedLeg.market.name,
        type: feedLeg.market.type,
        points: feedLeg.market.points ?? null,
      },
      selection: {
        name: feedLeg.label,
        odds: { american: outcome.odds_american },
        outcome_id: outcome.outcome_id,
        bet_offer_id: outcome.bet_offer_id,
        event_id: event?.id,
      },
      provider_payload: {
        ...feedLeg.provider_payload,
        outcome_id: outcome.outcome_id,
        bet_offer_id: outcome.bet_offer_id,
        participant: outcome.participant || null,
        bet_offer_type: outcome.bet_offer_type || null,
        market_status: outcome.market_status || null,
        outcome_status: outcome.outcome_status || null,
      },
    }
  }

  const label = kambiOutcomeLabel(outcome)
  return {
    label,
    event: {
      name: outcome.event_name || '',
      id: event?.id,
      start_time: event?.start || outcome.event_start || null,
    },
    market: {
      name: outcome.criterion || outcome.bet_offer_type || '',
      type: outcome.bet_offer_type || '',
      points: outcome.line ?? outcome.points ?? null,
    },
    selection: {
      name: label,
      odds: { american: outcome.odds_american },
      outcome_id: outcome.outcome_id,
      bet_offer_id: outcome.bet_offer_id,
      event_id: event?.id,
    },
    // No line or points: the cached outcome only has formatted values, and the
    // widget reads a Kambi payload line as milli-units.
    provider_payload: {
      provider: 'kambi',
      outcome_id: outcome.outcome_id,
      bet_offer_id: outcome.bet_offer_id,
      participant: outcome.participant || null,
      criterion: outcome.criterion || null,
      bet_offer_type: outcome.bet_offer_type || null,
      market_status: outcome.market_status || null,
      outcome_status: outcome.outcome_status || null,
    },
  }
}
